module.exports = __webpack_public_path__ + "assets/img/7_312.775f4dc5.jpg";